import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { ApplicationErrorPage, NotFoundErrorPage, RedirectPage } from 'modules/application/views';
import { CreateServiceCallPage, ServiceCallPage, ServiceCallSubmissionConfirmationPage } from 'modules/service-call/views';
import { PageLayout } from 'components/Layouts';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { TermsAndConditionsPage } from 'modules/application/views/TermsAndConditionsPage';
import { PrivacyPolicyPage } from 'modules/application/views/PrivacyPolicyPage';

interface AppProps {
  tenantId?: string
}


export const App: React.FC<AppProps> = ({ tenantId }) => {
  const theme = useTheme();
  const intl = useIntl();

  return (
    <PageLayout>
      <Helmet htmlAttributes={{ lang: intl.locale }}>
        <meta name='theme-color' content={theme.palette.primary.main} />
        <meta name='color-scheme' content='light' />
      </Helmet>

      {tenantId ?
        (
          <BrowserRouter basename={tenantId}>
            <Routes>
              <Route path='/' element={<CreateServiceCallPage />} />
              <Route path='/service-calls/:serviceCallId' element={<ServiceCallPage />} />
              <Route path='/submission-confirmation' element={<ServiceCallSubmissionConfirmationPage />} />
              <Route path='/error/500' element={<ApplicationErrorPage />} />
              <Route path='*' element={<NotFoundErrorPage />} />
            </Routes>
          </BrowserRouter>
        ) : (
          <BrowserRouter>
            <Routes>
              <Route path='/' element={<RedirectPage />} />
              <Route path='/error/500' element={<ApplicationErrorPage />} />
              <Route path='*' element={<NotFoundErrorPage />} />
              <Route path='/terms-and-conditions' element={<TermsAndConditionsPage />} />
              <Route path='/privacy-policy' element={<PrivacyPolicyPage />} />
            </Routes>
          </BrowserRouter>
        )}

    </PageLayout>
  );
};